import { AnalyticsRepository } from '../../domain/repositories/analytics.repository';

export class TrackProductViewUseCase {
  constructor(private readonly analyticsRepository: AnalyticsRepository) {}

  public async execute(productId: string): Promise<void> {
    await this.analyticsRepository.trackProductView(productId);
  }
}

export class TrackSearchUseCase {
  constructor(private readonly analyticsRepository: AnalyticsRepository) {}

  public async execute(query: string, resultsCount: number = 0): Promise<void> {
    await this.analyticsRepository.trackSearch(query, resultsCount);
  }
}

export class TrackProductInquiryUseCase {
  constructor(private readonly analyticsRepository: AnalyticsRepository) {}

  public async execute(
    productId: string,
    origin: 'catalog_card' | 'product_detail' = 'catalog_card'
  ): Promise<void> {
    await this.analyticsRepository.trackProductInquiry(productId, origin);
  }
}
